export default {
  number: '+4733221200',
  display: '33 - 22 12 00',
  currency: 'NOK',
  tracking: {},
};
